import { FastField, Field, getIn } from "formik";
import { flatten } from "@reside/forms/dist/flatten";
import * as immutable from "object-path-immutable";
export const getFormFieldComponent = (name, options) => {
    if (!Array.isArray(options)) {
        return isFastFieldCapable(name) ? FastField : Field;
    }
    return isFastFieldCapable(name) && !options.some(option => option.children)
        ? FastField
        : Field;
};
/**
 * Fast field can not be used when field is dependant on other field values
 */
export const isFastFieldCapable = (name) => !isArrayField(name);
const isArrayField = (name) => name.includes(".");
export const isInvalid = (fieldName, form) => getFormFieldError(fieldName, form) && isFormFieldTouched(fieldName, form);
export const getFormFieldError = (fieldName, form) => immutable.get(form.errors, fieldName) ||
    getIn(form.errors, fieldName) ||
    form.errors[fieldName];
const isFormFieldTouched = (fieldName, form) => 
// nested fields that are visible only if json logic is true are not registered and formik can not properly mark them as touched
form.submitCount > 0 ||
    immutable.get(form.touched, fieldName) ||
    getIn(form.touched, fieldName) ||
    Object.prototype.hasOwnProperty.call(flatten(form.touched), fieldName);
/**
 * Constructs the FILE variable which can be saved to facility settings.
 */
export const makeFileVariable = (data) => ({
    ...data,
    type: "FILE",
});
export const getPreSignedUrl = async (originalUrl, transformUrl) => {
    // The transformUrl function is expected to:
    // 1. Convert /api/files/ URLs to /v3/files/ format
    // 2. Add authentication (e.g., access token)
    const transformedUrl = transformUrl(originalUrl);
    // Fetch pre-signed URL from backend
    const response = await fetch(transformedUrl);
    if (!response.ok) {
        throw new Error(`Failed to fetch pre-signed URL: ${response.statusText}`);
    }
    const data = await response.json();
    return data.url;
};
